{
	"products": "Products",
	"selectDisclaimer": "Download selected products in excel and edit them. Then upload the file to update your menu",
	"xlsxDisclaimer": "Now that you have edited the products in excel, upload the file and we will update your list of products in this menu",
	"label": "File name",
	"download": "Download",
	"editMassProduct": "Mass product editing",
	"sheet": {
		"id": "IDENTIFIER (DO NOT EDIT)",
		"sku": "SKU",
		"name": "Name",
		"category": "Category",
		"description": "Description",
		"price": "Price",
		"filename": "edit-products-in-mass-delivery",
		"invalidFormat": "Invalid format"
	}
}
